__turbopack_context__.v({
  "check": "Checkbox-module-scss-module__qKUFFW__check",
  "checkbox": "Checkbox-module-scss-module__qKUFFW__checkbox",
  "checkbox-control": "Checkbox-module-scss-module__qKUFFW__checkbox-control",
  "checkbox-input": "Checkbox-module-scss-module__qKUFFW__checkbox-input",
  "checkbox-label": "Checkbox-module-scss-module__qKUFFW__checkbox-label",
  "checkbox-wave": "Checkbox-module-scss-module__qKUFFW__checkbox-wave",
});
